import { toast } from 'react-toastify';

import { BackendRoute } from '../../../../config/index';
import { QueryKey } from '../../../../constants/index';
import { useAppMutation, useInvalidateQueries } from '../../../../hooks/index';
import { ApiService } from '../../../../services/index';
import { Perk } from '../perks.types';

export const useDeactivatePerk = () => {
  const { invalidateQuery } = useInvalidateQueries(QueryKey.PERKS);
  const body: Partial<Pick<Perk, 'active'>> = { active: false };
  const { mutate: deactivatePerk, isPending } = useAppMutation([QueryKey.PERKS, QueryKey.PATCH], {
    mutationFn: ({ id }: { id: string }) =>
      ApiService.patch(
        {
          endpoint: BackendRoute.PERKS,
          routePath: [id],
        },
        { regularBackend: true, body },
      ),
    onSuccess: (_, { id }) => {
      invalidateQuery(id);
      toast.success('Perk is deactivated');
    },
    defaultErrorHandling: false,
    onError: () => {
      toast.error('Couldn’t deactivate. Please try again');
    },
  });

  return {
    isPending,
    deactivatePerk,
  };
};
